var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dashboardPagesLayout',[_c('div',{staticClass:"p-inside-manage"},[_c('div',{staticClass:"page_title"},[_vm._v("Merch")]),_c('div',{staticClass:"wrap_manage_table under_construction"},[_c('span',[_vm._v("In development")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }